module.exports = __webpack_public_path__ + "static/img/confirm1.ce95828.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/confirm1.png
// module id = 898
// module chunks = 1